const state = {
  env: process.env.NODE_ENV
};

const getters = {
  env(state) {
    return state.env;
  }
};

export default {
  state,
  getters
};
